import React, { useRef, useState, useEffect } from 'react';
import { PhoneMockup } from './PhoneMockup';
import { PredictionDemo } from './demos/PredictionDemo';
import { LMSPickDemo } from './demos/LMSPickDemo';
import { LeaderboardDemo } from './demos/LeaderboardDemo';
import { WhatsAppDemo } from './demos/WhatsAppDemo';

const demos = [
  { id: 'predictions', title: 'Score Predictions', description: 'Predict match scores and earn points for accuracy', component: <PredictionDemo /> },
  { id: 'lms', title: 'Last Man Standing', description: "Pick a team to win each week - one wrong pick and you're out", component: <LMSPickDemo /> },
  { id: 'leaderboard', title: 'Live Leaderboards', description: 'Track your position and see how others are doing', component: <LeaderboardDemo /> },
  { id: 'whatsapp', title: 'WhatsApp Notifications', description: 'Get instant updates on your picks and results', component: <WhatsAppDemo />, screenBackground: 'bg-[#0b141a]' },
];

export const AnimatedDemoSection: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(mq.matches);
    const handler = (e: MediaQueryListEvent) => setPrefersReducedMotion(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setIsVisible(true); }, { threshold: 0.1 });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
      {demos.map((demo, index) => (
        <div key={demo.id} className="flex flex-col items-center" style={prefersReducedMotion ? {} : { opacity: isVisible ? 1 : 0, transform: isVisible ? 'translateY(0)' : 'translateY(30px)', transition: `opacity 0.6s ease-out ${index * 0.15}s, transform 0.6s ease-out ${index * 0.15}s` }}>
          <PhoneMockup screenBackground={demo.screenBackground}>{demo.component}</PhoneMockup>
          <div className="mt-6 text-center">
            <h3 className="text-lg font-bold text-white mb-2">{demo.title}</h3>
            <p className="text-white/60 text-sm">{demo.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
